import { PriceRangeFilterState } from './store/priceRange.types';

export const priceRangeFilterHash = (options: PriceRangeFilterState['priceRange']): string =>
  Object.keys(options)
    .filter((rangeId) => !!options[Number(rangeId)])
    .sort()
    .join('.');
